import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { useSelector } from 'react-redux';

import LoginPage     from './pages/Auth/LoginPage';
import RegisterPage  from './pages/Auth/RegisterPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import PortfolioPage from './pages/Portfolio/PortfolioPage';
import MarketPage from './pages/Markets/MarketPage';
import PredictionsPage from './pages/Predictions/PredictionsPage';
import AlertsPage from './pages/Alerts/AlertsPage';
import AccuracyPage from './pages/Accuracy/AccuracyPage';
import AppLayout     from './components/Layout/AppLayout';

function ProtectedRoute({ children }) {
  const { token } = useSelector(state => state.auth);
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login"    element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard"     element={<DashboardPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio/:market" element={<PortfolioPage />} />
          <Route path="predictions" element={<PredictionsPage />} />
          <Route path="predictions/:market" element={<PredictionsPage />} />
          <Route path="markets/:market" element={<MarketPage />} />
          <Route path="alerts" element={<AlertsPage />} />
          <Route path="reports"       element={<div className="page"><div className="page-title">Reports — Coming in Phase 2</div></div>} />
          <Route path="accuracy" element={<AccuracyPage />} />
          
          <Route path="admin"         element={<div className="page"><div className="page-title">Admin — Coming in Phase 2</div></div>} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
}